// Lazy-loads zxing-wasm's reader module.
//
// event-connect (Vite) self-hosts the wasm binary via a `?url` asset import so it never fetches
// from a CDN — Vite-only syntax with no webpack equivalent, so it does not port over as-is. Left
// un-overridden, zxing-wasm's own default `locateFile` (dist/share.ts) already resolves the
// exact-version wasm binary from the jsDelivr CDN, which needs zero webpack asset config and
// works identically in develop/build/SSR. The tradeoff versus event-connect's approach is one
// CDN round trip per session instead of a same-origin file; revisit (webpack asset/resource rule
// + explicit locateFile override) if that round trip ever shows up as a real problem.
export type ZxingReaderModule = typeof import('zxing-wasm/reader')

let readerPromise: Promise<ZxingReaderModule> | null = null

export function loadZxingReader(): Promise<ZxingReaderModule> {
  // `self` (not `window`) is the check that works from both a browser tab and a Worker.
  // Neither exists during SSR (Gatsby build-html/develop-html).
  if (typeof self === 'undefined') {
    return Promise.reject(new Error('zxing-wasm reader is client-only'))
  }
  if (!readerPromise) {
    readerPromise = import('zxing-wasm/reader').catch((error: unknown) => {
      // Reset so a later mount retries instead of inheriting a rejected promise.
      readerPromise = null
      throw error
    })
  }
  return readerPromise
}
